
export default class Slide {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.splide'];

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		new Splide(holderElement).mount();
	}

}
